import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ModelOptions } from './model-options';

export interface JsonDurationModelOptions {
    minValue: string;
    maxValue: string;
    placeholder: string;
    required: boolean;
    step: number;
    unit: string;
    format: DURATION_ODATA_FORMAT;
    readonly: boolean;
}

export enum DURATION_ODATA_FORMAT {
    STANDARD,
    MINUTES,
}

/**
 *  Configure the behaviour of a DurationModel
 */
export class DurationModelOptions extends ModelOptions {
    /**
     * Constructor that expects an object with some or all of the supported options set
     */
    public readonly minValue: moment.Duration;
    public readonly maxValue: moment.Duration;
    public readonly placeholder: string;
    public readonly required: boolean;
    public readonly step: number;
    public readonly unit: moment.unitOfTime.Base;
    public readonly format: DURATION_ODATA_FORMAT;
    public readonly readonly: boolean;
    public constructor({
        minValue = moment.duration(0),
        maxValue = moment.duration(0).add(ConfigConstants.maxAmountOfYears, 'years'),
        placeholder = '',
        required = false,
        step = 1,
        unit = <moment.unitOfTime.Base>'minutes',
        format = DURATION_ODATA_FORMAT.STANDARD,
        readonly = false,
    } = {}) {
        super();
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.placeholder = placeholder;
        this.required = required;
        this.step = step;
        this.unit = unit;
        this.format = format;
        this.readonly = readonly;
    }
}

export class DurationModelOptionsFromJson extends DurationModelOptions {
    public constructor(data: JsonDurationModelOptions) {
        super({
            minValue: data.minValue ? moment.duration(data.minValue) : moment.duration(0),
            maxValue: data.maxValue
                ? moment.duration(data.maxValue)
                : moment.duration(0).add(ConfigConstants.maxAmountOfYears, 'years'),
            placeholder: data.placeholder,
            required: data.required,
            step: data.step,
            unit: <moment.unitOfTime.Base>data.unit,
            format: data.format,
            readonly: data.readonly,
        });
    }
}
